<template>
    <div class="network-invites" :class="{loading: loading}">
        <fieldset>
            <legend>
                <div class="row">
                    <div class="col-sm-6 col-md-7 text-right form-group pull-sm-right">
                        Network Access
                    </div>

                    <div class="col-sm-6 col-md-5 form-group align-sm-left">
                        <button type="button" class="btn btn-success" @click="open(null)" :disabled="loading"
                                v-if="models.length === 0">
                            Grant Access
                        </button>
                    </div>
                </div>
            </legend>

            <div class="list-group">
                <a href="javascript://void(0)" class="list-group-item"
                   :class="{'list-group-item-success active':selectedModelId === model.id}"
                   v-for="model in models"
                   :key="model.id"
                   @click="open(model.id)">
                    <h4 class="list-group-item-heading">
                        {{model.email}}
                        <span v-if="model.statusLabel" v-html="model.statusLabel"></span>
                        <span v-if="model.archivedLabel" v-html="model.archivedLabel"></span>
                    </h4>
                    <h6>
                        {{model.start_at ? model.start_at.format('MMM, Do YYYY') : 'none'}} -
                        {{model.end_at ? model.end_at.format('MMM, Do YYYY') : 'none'}}
                    </h6>
                </a>
            </div>
        </fieldset>

        <network-invite ref="networkInviteComponent"
                        :project-id="projectId"
                        :inviteable-id="inviteableId"
                        :inviteable-type="inviteableType"
                        :model-id="selectedModelId"
                        @afterSave="afterSave">
            <span></span>
        </network-invite>
    </div>
</template>

<script>
    import models from "./mixins/models";
    import NetworkInvite from "./NetworkInvite";

    export default {
        components: { NetworkInvite },
        mixins: [ models ],

        props: {
            inviteables: {
                default: () => {
                    return [];
                },
                type: Array
            },

            inviteableType: {
                default: null,
                type: String
            },

            inviteableId: {
                default: null,
                type: String
            },

            projectId: {
                required: true,
                type: String
            },
        },

        computed: {
            url(){
                var originalUrl, url;

                originalUrl = '/api/networkInvites?';
                url = originalUrl;

                if( _.isEmpty( this.inviteables ) ){
                    if( this.inviteableType ){
                        url += '&inviteable_type=' + this.inviteableType;
                    }

                    if( this.inviteableId ){
                        url += '&inviteable_id=' + this.inviteableId;
                    }
                }
                else {
                    // or[i][filter]=filterValue
                    _.forEach( this.inviteables, ( inviteable, key ) => {
                        if( !inviteable.inviteable_type ){
                            console.error( 'Missing inviteable_type in inviteables prop' );
                        }
                        else if( !inviteable.inviteable_id ){
                            console.error( 'Missing inviteable_id in inviteables prop' );
                        }

                        url += '&or[' + key + '][inviteable_type]=' + inviteable.inviteable_type;
                        url += '&or[' + key + '][inviteable_id]=' + inviteable.inviteable_id;
                    } );
                }

                // One filter option is required
                if( originalUrl === url ){
                    throw new Error( 'No filter options selected' );
                }

                return url;
            },

            modelComponent(){
                return 'networkInviteComponent';
            },

            resourceKey(){
                return 'NetworkInvites';
            },
        },

        methods: {
            setModels( response ){
                return this.$set( this, 'models', _.map( response.data[ this.resourceKey ], ( model ) => {
                    model.start_at = model.start_at ? moment.utc( model.start_at ) : null;
                    model.end_at = model.end_at ? moment.utc( model.end_at ) : null;

                    return model;
                } ) );
            },

            getModelsData(){
                return {
                    archived: true
                };
            },
        }
    }
</script>
